import {
  LogoAlectaBlack,
  LogoAlectaWhite,
  LogoHumlegardenBlack,
  LogoHumlegardenWhite,
  LogoRemondisWhite,
} from 'assets/logotype';

export interface ThanksContact {
  logoBlack: string;
  email: string;
  phone: string;
  alt: string;
}

export interface LandingPageConfig {
  heroTitle: string;
  logoPrimary: string;
  logoSecondary: string;
  thanksContact: ThanksContact;
}

export const LANDING_PAGE_SLUGS = ['alectafastigheter', 'humlegarden'] as const;
export type LandingPageSlug = (typeof LANDING_PAGE_SLUGS)[number];

export const landingPagesConfig: Record<LandingPageSlug, LandingPageConfig> = {
  alectafastigheter: {
    heroTitle:
      '"Vi på Alecta Fastigheter tycker att avfallssorteringen är viktig. Tillsammans med REMONDIS utvecklar vi nu det i fastigheten."',
    logoPrimary: LogoAlectaWhite,
    logoSecondary: LogoRemondisWhite,
    thanksContact: {
      logoBlack: LogoAlectaBlack,
      email: 'kontakt@alectafastigheter.se',
      phone: '08-441 90 00',
      alt: 'Alecta Fastigheter logo',
    },
  },
  humlegarden: {
    heroTitle:
      '"Vi vill göra det så enkelt som möjligt för dig att vara klimatsmart. Därför sorterar vi ditt avfall och ser till att i princip allt återvinns."',
    logoPrimary: LogoHumlegardenWhite,
    logoSecondary: LogoRemondisWhite,
    thanksContact: {
      logoBlack: LogoHumlegardenBlack,
      email: 'kontakt@humlegarden.se',
      phone: '08-123 45 67',
      alt: 'Humlegården Fastigheter logo',
    },
  },
};

export const getLandingPageConfig = (slug: string): LandingPageConfig | null => {
  if (LANDING_PAGE_SLUGS.includes(slug as LandingPageSlug)) {
    return landingPagesConfig[slug as LandingPageSlug];
  }
  return null;
};
